export const INTRO_STEP = {
  RENDER: 0,
  FADING_IN: 1,
  FADED_IN: 2,
  FADING_OUT: 3,
  FADED_OUT: 4,
};
